/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as CalendarRouteImport } from './routes/calendar'
import { Route as CatalogRouteImport } from './routes/catalog'
import { Route as CharactersRouteImport } from './routes/characters'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as FavoritesRouteImport } from './routes/favorites'
import { Route as GlossaryRouteImport } from './routes/glossary'
import { Route as ImpersonateRouteImport } from './routes/impersonate'
import { Route as MethodRouteImport } from './routes/method'
import { Route as OfflineRouteImport } from './routes/offline'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as ProgressRouteImport } from './routes/progress'
import { Route as SearchRouteImport } from './routes/search'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as TrashRouteImport } from './routes/trash'
import { Route as WeakSpotsRouteImport } from './routes/weak-spots'
import { Route as AudioRecapsIndexRouteImport } from './routes/audio-recaps/index'
import { Route as AudioRecapsIdRouteImport } from './routes/audio-recaps/$id'
import { Route as AudioRecapsNewRouteImport } from './routes/audio-recaps/new'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as BillingCheckoutRouteImport } from './routes/billing/checkout'
import { Route as BillingSuccessRouteImport } from './routes/billing/success'
import { Route as CatalogSlugRouteImport } from './routes/catalog_.$slug'
import { Route as CollectionsIndexRouteImport } from './routes/collections/index'
import { Route as CollectionsSetIdRouteImport } from './routes/collections/$setId'
import { Route as CoursesIndexRouteImport } from './routes/courses/index'
import { Route as CoursesCourseIdRouteImport } from './routes/courses/$courseId'
import { Route as CoursesCalendarRouteImport } from './routes/courses/calendar'
import { Route as CoursesCatalogRouteImport } from './routes/courses/catalog'
import { Route as CoursesNewRouteImport } from './routes/courses/new'
import { Route as CoursesTemplatesRouteImport } from './routes/courses/templates'
import { Route as FlashcardsIndexRouteImport } from './routes/flashcards/index'
import { Route as FlashcardsMarkedRouteImport } from './routes/flashcards/marked'
import { Route as LegalKindRouteImport } from './routes/legal/$kind'
import { Route as LegalAcceptRouteImport } from './routes/legal/accept'
import { Route as LibraryIndexRouteImport } from './routes/library/index'
import { Route as MaterialsIndexRouteImport } from './routes/materials/index'
import { Route as MaterialsMaterialIdRouteImport } from './routes/materials/$materialId'
import { Route as MaterialsTrashRouteImport } from './routes/materials/trash'
import { Route as NotesIndexRouteImport } from './routes/notes/index'
import { Route as NotesNoteIdRouteImport } from './routes/notes/$noteId'
import { Route as NotificationsIndexRouteImport } from './routes/notifications/index'
import { Route as NotificationsIdRouteImport } from './routes/notifications/$id'
import { Route as OnboardingIndexRouteImport } from './routes/onboarding/index'
import { Route as OnboardingDoneRouteImport } from './routes/onboarding/done'
import { Route as OnboardingLanguageRouteImport } from './routes/onboarding/language'
import { Route as OnboardingMethodRouteImport } from './routes/onboarding/method'
import { Route as OnboardingRhythmRouteImport } from './routes/onboarding/rhythm'
import { Route as RecordingsIndexRouteImport } from './routes/recordings/index'
import { Route as RecordingsIdRouteImport } from './routes/recordings/$id'
import { Route as RecordingsNewRouteImport } from './routes/recordings/new'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as SettingsAccountRouteImport } from './routes/settings/account'
import { Route as SettingsAppearanceRouteImport } from './routes/settings/appearance'
import { Route as SettingsBillingRouteImport } from './routes/settings/billing'
import { Route as SettingsDangerRouteImport } from './routes/settings/danger'
import { Route as SettingsDevicesRouteImport } from './routes/settings/devices'
import { Route as SettingsLanguageRouteImport } from './routes/settings/language'
import { Route as SettingsNotificationsRouteImport } from './routes/settings/notifications'
import { Route as SettingsOfflineRouteImport } from './routes/settings/offline'
import { Route as SettingsPrivacyRouteImport } from './routes/settings/privacy'
import { Route as SettingsProfileRouteImport } from './routes/settings/profile'
import { Route as SettingsStreakRouteImport } from './routes/settings/streak'
import { Route as SharedTokenRouteImport } from './routes/shared/$token'
import { Route as StudyPlanIndexRouteImport } from './routes/study-plan/index'
import { Route as StudyPlanIdRouteImport } from './routes/study-plan/$id'
import { Route as StudyPlanCalendarRouteImport } from './routes/study-plan/calendar'
import { Route as StudyPlanTemplatesRouteImport } from './routes/study-plan/templates'
import { Route as TestsIndexRouteImport } from './routes/tests/index'
import { Route as TutorIndexRouteImport } from './routes/tutor/index'
import { Route as TutorSessionIdRouteImport } from './routes/tutor/$sessionId'
import { Route as TutorScenariosRouteImport } from './routes/tutor/scenarios'
import { Route as TutorSkillsRouteImport } from './routes/tutor/skills'
import { Route as VoiceTutorIndexRouteImport } from './routes/voice-tutor/index'
import { Route as VoiceTutorNewRouteImport } from './routes/voice-tutor/new'
import { Route as AudioRecapsShareTokenRouteImport } from './routes/audio-recaps/share/$token'
import { Route as BillingRefundStatusRefundIdRouteImport } from './routes/billing/refund-status.$refundId'
import { Route as CharactersSessionsIdRouteImport } from './routes/characters_.sessions.$id'
import { Route as CoursesCatalogTemplateIdRouteImport } from './routes/courses/catalog_.$templateId'
import { Route as CoursesTemplatesTemplateIdRouteImport } from './routes/courses/templates_.$templateId'
import { Route as FlashcardsSetsSetIdRouteImport } from './routes/flashcards/sets/$setId'
import { Route as FlashcardsStudySetIdRouteImport } from './routes/flashcards/study/$setId'
import { Route as LibraryFoldersIndexRouteImport } from './routes/library/folders/index'
import { Route as LibraryFoldersFolderIdRouteImport } from './routes/library/folders/$folderId'
import { Route as MaterialsMaterialIdNotesRouteImport } from './routes/materials/$materialId_/notes'
import { Route as MaterialsSetsIndexRouteImport } from './routes/materials/sets/index'
import { Route as MaterialsSetsSetIdRouteImport } from './routes/materials/sets/$setId'
import { Route as TestsEditIdRouteImport } from './routes/tests/edit/$id'
import { Route as TestsResultsAttemptIdRouteImport } from './routes/tests/results/$attemptId'
import { Route as TestsTakeIdRouteImport } from './routes/tests/take/$id'
import { Route as ToolsEssayIndexRouteImport } from './routes/tools/essay/index'
import { Route as ToolsEssayIdRouteImport } from './routes/tools/essay/$id'
import { Route as ToolsVisualExplainerIndexRouteImport } from './routes/tools/visual-explainer/index'
import { Route as ToolsVisualExplainerIdRouteImport } from './routes/tools/visual-explainer/$id'
import { Route as ToolsVisualsIndexRouteImport } from './routes/tools/visuals/index'
import { Route as ToolsVisualsIdRouteImport } from './routes/tools/visuals/$id'
import { Route as VoiceTutorSessionIdRouteImport } from './routes/voice-tutor/session/$id'
import { Route as CoursesCourseIdTopicsTopicIdRouteImport } from './routes/courses/$courseId_.topics.$topicId'
import { Route as StudyPlanIdSubsectionSubIdRouteImport } from './routes/study-plan/$id_.subsection.$subId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const CalendarRoute = CalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogRoute = CatalogRouteImport.update({
  id: '/catalog',
  path: '/catalog',
  getParentRoute: () => rootRouteImport,
} as any)
const CharactersRoute = CharactersRouteImport.update({
  id: '/characters',
  path: '/characters',
  getParentRoute: () => rootRouteImport,
} as any)
const FaqRoute = FaqRouteImport.update({
  id: '/faq',
  path: '/faq',
  getParentRoute: () => rootRouteImport,
} as any)
const FavoritesRoute = FavoritesRouteImport.update({
  id: '/favorites',
  path: '/favorites',
  getParentRoute: () => rootRouteImport,
} as any)
const GlossaryRoute = GlossaryRouteImport.update({
  id: '/glossary',
  path: '/glossary',
  getParentRoute: () => rootRouteImport,
} as any)
const ImpersonateRoute = ImpersonateRouteImport.update({
  id: '/impersonate',
  path: '/impersonate',
  getParentRoute: () => rootRouteImport,
} as any)
const MethodRoute = MethodRouteImport.update({
  id: '/method',
  path: '/method',
  getParentRoute: () => rootRouteImport,
} as any)
const OfflineRoute = OfflineRouteImport.update({
  id: '/offline',
  path: '/offline',
  getParentRoute: () => rootRouteImport,
} as any)
const PricingRoute = PricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const ProgressRoute = ProgressRouteImport.update({
  id: '/progress',
  path: '/progress',
  getParentRoute: () => rootRouteImport,
} as any)
const SearchRoute = SearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const TrashRoute = TrashRouteImport.update({
  id: '/trash',
  path: '/trash',
  getParentRoute: () => rootRouteImport,
} as any)
const WeakSpotsRoute = WeakSpotsRouteImport.update({
  id: '/weak-spots',
  path: '/weak-spots',
  getParentRoute: () => rootRouteImport,
} as any)
const AudioRecapsIndexRoute = AudioRecapsIndexRouteImport.update({
  id: '/audio-recaps/',
  path: '/audio-recaps/',
  getParentRoute: () => rootRouteImport,
} as any)
const AudioRecapsIdRoute = AudioRecapsIdRouteImport.update({
  id: '/audio-recaps/$id',
  path: '/audio-recaps/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AudioRecapsNewRoute = AudioRecapsNewRouteImport.update({
  id: '/audio-recaps/new',
  path: '/audio-recaps/new',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingCheckoutRoute = BillingCheckoutRouteImport.update({
  id: '/billing/checkout',
  path: '/billing/checkout',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingSuccessRoute = BillingSuccessRouteImport.update({
  id: '/billing/success',
  path: '/billing/success',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogSlugRoute = CatalogSlugRouteImport.update({
  id: '/catalog_/$slug',
  path: '/catalog/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const CollectionsIndexRoute = CollectionsIndexRouteImport.update({
  id: '/collections/',
  path: '/collections/',
  getParentRoute: () => rootRouteImport,
} as any)
const CollectionsSetIdRoute = CollectionsSetIdRouteImport.update({
  id: '/collections/$setId',
  path: '/collections/$setId',
  getParentRoute: () => rootRouteImport,
} as any)
const CoursesIndexRoute = CoursesIndexRouteImport.update({
  id: '/courses/',
  path: '/courses/',
  getParentRoute: () => rootRouteImport,
} as any)
const CoursesCourseIdRoute = CoursesCourseIdRouteImport.update({
  id: '/courses/$courseId',
  path: '/courses/$courseId',
  getParentRoute: () => rootRouteImport,
} as any)
const CoursesCalendarRoute = CoursesCalendarRouteImport.update({
  id: '/courses/calendar',
  path: '/courses/calendar',
  getParentRoute: () => rootRouteImport,
} as any)
const CoursesCatalogRoute = CoursesCatalogRouteImport.update({
  id: '/courses/catalog',
  path: '/courses/catalog',
  getParentRoute: () => rootRouteImport,
} as any)
const CoursesNewRoute = CoursesNewRouteImport.update({
  id: '/courses/new',
  path: '/courses/new',
  getParentRoute: () => rootRouteImport,
} as any)
const CoursesTemplatesRoute = CoursesTemplatesRouteImport.update({
  id: '/courses/templates',
  path: '/courses/templates',
  getParentRoute: () => rootRouteImport,
} as any)
const FlashcardsIndexRoute = FlashcardsIndexRouteImport.update({
  id: '/flashcards/',
  path: '/flashcards/',
  getParentRoute: () => rootRouteImport,
} as any)
const FlashcardsMarkedRoute = FlashcardsMarkedRouteImport.update({
  id: '/flashcards/marked',
  path: '/flashcards/marked',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalKindRoute = LegalKindRouteImport.update({
  id: '/legal/$kind',
  path: '/legal/$kind',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalAcceptRoute = LegalAcceptRouteImport.update({
  id: '/legal/accept',
  path: '/legal/accept',
  getParentRoute: () => rootRouteImport,
} as any)
const LibraryIndexRoute = LibraryIndexRouteImport.update({
  id: '/library/',
  path: '/library/',
  getParentRoute: () => rootRouteImport,
} as any)
const MaterialsIndexRoute = MaterialsIndexRouteImport.update({
  id: '/materials/',
  path: '/materials/',
  getParentRoute: () => rootRouteImport,
} as any)
const MaterialsMaterialIdRoute = MaterialsMaterialIdRouteImport.update({
  id: '/materials/$materialId',
  path: '/materials/$materialId',
  getParentRoute: () => rootRouteImport,
} as any)
const MaterialsTrashRoute = MaterialsTrashRouteImport.update({
  id: '/materials/trash',
  path: '/materials/trash',
  getParentRoute: () => rootRouteImport,
} as any)
const NotesIndexRoute = NotesIndexRouteImport.update({
  id: '/notes/',
  path: '/notes/',
  getParentRoute: () => rootRouteImport,
} as any)
const NotesNoteIdRoute = NotesNoteIdRouteImport.update({
  id: '/notes/$noteId',
  path: '/notes/$noteId',
  getParentRoute: () => rootRouteImport,
} as any)
const NotificationsIndexRoute = NotificationsIndexRouteImport.update({
  id: '/notifications/',
  path: '/notifications/',
  getParentRoute: () => rootRouteImport,
} as any)
const NotificationsIdRoute = NotificationsIdRouteImport.update({
  id: '/notifications/$id',
  path: '/notifications/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingIndexRoute = OnboardingIndexRouteImport.update({
  id: '/onboarding/',
  path: '/onboarding/',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingDoneRoute = OnboardingDoneRouteImport.update({
  id: '/onboarding/done',
  path: '/onboarding/done',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingLanguageRoute = OnboardingLanguageRouteImport.update({
  id: '/onboarding/language',
  path: '/onboarding/language',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingMethodRoute = OnboardingMethodRouteImport.update({
  id: '/onboarding/method',
  path: '/onboarding/method',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRhythmRoute = OnboardingRhythmRouteImport.update({
  id: '/onboarding/rhythm',
  path: '/onboarding/rhythm',
  getParentRoute: () => rootRouteImport,
} as any)
const RecordingsIndexRoute = RecordingsIndexRouteImport.update({
  id: '/recordings/',
  path: '/recordings/',
  getParentRoute: () => rootRouteImport,
} as any)
const RecordingsIdRoute = RecordingsIdRouteImport.update({
  id: '/recordings/$id',
  path: '/recordings/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const RecordingsNewRoute = RecordingsNewRouteImport.update({
  id: '/recordings/new',
  path: '/recordings/new',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsAccountRoute = SettingsAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsAppearanceRoute = SettingsAppearanceRouteImport.update({
  id: '/appearance',
  path: '/appearance',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsBillingRoute = SettingsBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsDangerRoute = SettingsDangerRouteImport.update({
  id: '/danger',
  path: '/danger',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsDevicesRoute = SettingsDevicesRouteImport.update({
  id: '/devices',
  path: '/devices',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsLanguageRoute = SettingsLanguageRouteImport.update({
  id: '/language',
  path: '/language',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsNotificationsRoute = SettingsNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsOfflineRoute = SettingsOfflineRouteImport.update({
  id: '/offline',
  path: '/offline',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsPrivacyRoute = SettingsPrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsProfileRoute = SettingsProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsStreakRoute = SettingsStreakRouteImport.update({
  id: '/streak',
  path: '/streak',
  getParentRoute: () => SettingsRoute,
} as any)
const SharedTokenRoute = SharedTokenRouteImport.update({
  id: '/shared/$token',
  path: '/shared/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const StudyPlanIndexRoute = StudyPlanIndexRouteImport.update({
  id: '/study-plan/',
  path: '/study-plan/',
  getParentRoute: () => rootRouteImport,
} as any)
const StudyPlanIdRoute = StudyPlanIdRouteImport.update({
  id: '/study-plan/$id',
  path: '/study-plan/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const StudyPlanCalendarRoute = StudyPlanCalendarRouteImport.update({
  id: '/study-plan/calendar',
  path: '/study-plan/calendar',
  getParentRoute: () => rootRouteImport,
} as any)
const StudyPlanTemplatesRoute = StudyPlanTemplatesRouteImport.update({
  id: '/study-plan/templates',
  path: '/study-plan/templates',
  getParentRoute: () => rootRouteImport,
} as any)
const TestsIndexRoute = TestsIndexRouteImport.update({
  id: '/tests/',
  path: '/tests/',
  getParentRoute: () => rootRouteImport,
} as any)
const TutorIndexRoute = TutorIndexRouteImport.update({
  id: '/tutor/',
  path: '/tutor/',
  getParentRoute: () => rootRouteImport,
} as any)
const TutorSessionIdRoute = TutorSessionIdRouteImport.update({
  id: '/tutor/$sessionId',
  path: '/tutor/$sessionId',
  getParentRoute: () => rootRouteImport,
} as any)
const TutorScenariosRoute = TutorScenariosRouteImport.update({
  id: '/tutor/scenarios',
  path: '/tutor/scenarios',
  getParentRoute: () => rootRouteImport,
} as any)
const TutorSkillsRoute = TutorSkillsRouteImport.update({
  id: '/tutor/skills',
  path: '/tutor/skills',
  getParentRoute: () => rootRouteImport,
} as any)
const VoiceTutorIndexRoute = VoiceTutorIndexRouteImport.update({
  id: '/voice-tutor/',
  path: '/voice-tutor/',
  getParentRoute: () => rootRouteImport,
} as any)
const VoiceTutorNewRoute = VoiceTutorNewRouteImport.update({
  id: '/voice-tutor/new',
  path: '/voice-tutor/new',
  getParentRoute: () => rootRouteImport,
} as any)
const AudioRecapsShareTokenRoute = AudioRecapsShareTokenRouteImport.update({
  id: '/audio-recaps/share/$token',
  path: '/audio-recaps/share/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingRefundStatusRefundIdRoute =
  BillingRefundStatusRefundIdRouteImport.update({
    id: '/billing/refund-status/$refundId',
    path: '/billing/refund-status/$refundId',
    getParentRoute: () => rootRouteImport,
  } as any)
const CharactersSessionsIdRoute = CharactersSessionsIdRouteImport.update({
  id: '/characters_/sessions/$id',
  path: '/characters/sessions/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const CoursesCatalogTemplateIdRoute =
  CoursesCatalogTemplateIdRouteImport.update({
    id: '/courses/catalog_/$templateId',
    path: '/courses/catalog/$templateId',
    getParentRoute: () => rootRouteImport,
  } as any)
const CoursesTemplatesTemplateIdRoute =
  CoursesTemplatesTemplateIdRouteImport.update({
    id: '/courses/templates_/$templateId',
    path: '/courses/templates/$templateId',
    getParentRoute: () => rootRouteImport,
  } as any)
const FlashcardsSetsSetIdRoute = FlashcardsSetsSetIdRouteImport.update({
  id: '/flashcards/sets/$setId',
  path: '/flashcards/sets/$setId',
  getParentRoute: () => rootRouteImport,
} as any)
const FlashcardsStudySetIdRoute = FlashcardsStudySetIdRouteImport.update({
  id: '/flashcards/study/$setId',
  path: '/flashcards/study/$setId',
  getParentRoute: () => rootRouteImport,
} as any)
const LibraryFoldersIndexRoute = LibraryFoldersIndexRouteImport.update({
  id: '/library/folders/',
  path: '/library/folders/',
  getParentRoute: () => rootRouteImport,
} as any)
const LibraryFoldersFolderIdRoute = LibraryFoldersFolderIdRouteImport.update({
  id: '/library/folders/$folderId',
  path: '/library/folders/$folderId',
  getParentRoute: () => rootRouteImport,
} as any)
const MaterialsMaterialIdNotesRoute =
  MaterialsMaterialIdNotesRouteImport.update({
    id: '/materials/$materialId_/notes',
    path: '/materials/$materialId/notes',
    getParentRoute: () => rootRouteImport,
  } as any)
const MaterialsSetsIndexRoute = MaterialsSetsIndexRouteImport.update({
  id: '/materials/sets/',
  path: '/materials/sets/',
  getParentRoute: () => rootRouteImport,
} as any)
const MaterialsSetsSetIdRoute = MaterialsSetsSetIdRouteImport.update({
  id: '/materials/sets/$setId',
  path: '/materials/sets/$setId',
  getParentRoute: () => rootRouteImport,
} as any)
const TestsEditIdRoute = TestsEditIdRouteImport.update({
  id: '/tests/edit/$id',
  path: '/tests/edit/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const TestsResultsAttemptIdRoute = TestsResultsAttemptIdRouteImport.update({
  id: '/tests/results/$attemptId',
  path: '/tests/results/$attemptId',
  getParentRoute: () => rootRouteImport,
} as any)
const TestsTakeIdRoute = TestsTakeIdRouteImport.update({
  id: '/tests/take/$id',
  path: '/tests/take/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ToolsEssayIndexRoute = ToolsEssayIndexRouteImport.update({
  id: '/tools/essay/',
  path: '/tools/essay/',
  getParentRoute: () => rootRouteImport,
} as any)
const ToolsEssayIdRoute = ToolsEssayIdRouteImport.update({
  id: '/tools/essay/$id',
  path: '/tools/essay/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ToolsVisualExplainerIndexRoute =
  ToolsVisualExplainerIndexRouteImport.update({
    id: '/tools/visual-explainer/',
    path: '/tools/visual-explainer/',
    getParentRoute: () => rootRouteImport,
  } as any)
const ToolsVisualExplainerIdRoute = ToolsVisualExplainerIdRouteImport.update({
  id: '/tools/visual-explainer/$id',
  path: '/tools/visual-explainer/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ToolsVisualsIndexRoute = ToolsVisualsIndexRouteImport.update({
  id: '/tools/visuals/',
  path: '/tools/visuals/',
  getParentRoute: () => rootRouteImport,
} as any)
const ToolsVisualsIdRoute = ToolsVisualsIdRouteImport.update({
  id: '/tools/visuals/$id',
  path: '/tools/visuals/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const VoiceTutorSessionIdRoute = VoiceTutorSessionIdRouteImport.update({
  id: '/voice-tutor/session/$id',
  path: '/voice-tutor/session/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const CoursesCourseIdTopicsTopicIdRoute =
  CoursesCourseIdTopicsTopicIdRouteImport.update({
    id: '/courses/$courseId_/topics/$topicId',
    path: '/courses/$courseId/topics/$topicId',
    getParentRoute: () => rootRouteImport,
  } as any)
const StudyPlanIdSubsectionSubIdRoute =
  StudyPlanIdSubsectionSubIdRouteImport.update({
    id: '/study-plan/$id_/subsection/$subId',
    path: '/study-plan/$id/subsection/$subId',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/calendar': typeof CalendarRoute
  '/catalog': typeof CatalogRoute
  '/characters': typeof CharactersRoute
  '/faq': typeof FaqRoute
  '/favorites': typeof FavoritesRoute
  '/glossary': typeof GlossaryRoute
  '/impersonate': typeof ImpersonateRoute
  '/method': typeof MethodRoute
  '/offline': typeof OfflineRoute
  '/pricing': typeof PricingRoute
  '/progress': typeof ProgressRoute
  '/search': typeof SearchRoute
  '/settings': typeof SettingsRouteWithChildren
  '/trash': typeof TrashRoute
  '/weak-spots': typeof WeakSpotsRoute
  '/audio-recaps/$id': typeof AudioRecapsIdRoute
  '/audio-recaps/new': typeof AudioRecapsNewRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/login': typeof AuthLoginRoute
  '/billing/checkout': typeof BillingCheckoutRoute
  '/billing/success': typeof BillingSuccessRoute
  '/catalog/$slug': typeof CatalogSlugRoute
  '/collections/$setId': typeof CollectionsSetIdRoute
  '/courses/$courseId': typeof CoursesCourseIdRoute
  '/courses/calendar': typeof CoursesCalendarRoute
  '/courses/catalog': typeof CoursesCatalogRoute
  '/courses/new': typeof CoursesNewRoute
  '/courses/templates': typeof CoursesTemplatesRoute
  '/flashcards/marked': typeof FlashcardsMarkedRoute
  '/legal/$kind': typeof LegalKindRoute
  '/legal/accept': typeof LegalAcceptRoute
  '/materials/$materialId': typeof MaterialsMaterialIdRoute
  '/materials/trash': typeof MaterialsTrashRoute
  '/notes/$noteId': typeof NotesNoteIdRoute
  '/notifications/$id': typeof NotificationsIdRoute
  '/onboarding/done': typeof OnboardingDoneRoute
  '/onboarding/language': typeof OnboardingLanguageRoute
  '/onboarding/method': typeof OnboardingMethodRoute
  '/onboarding/rhythm': typeof OnboardingRhythmRoute
  '/recordings/$id': typeof RecordingsIdRoute
  '/recordings/new': typeof RecordingsNewRoute
  '/settings/account': typeof SettingsAccountRoute
  '/settings/appearance': typeof SettingsAppearanceRoute
  '/settings/billing': typeof SettingsBillingRoute
  '/settings/danger': typeof SettingsDangerRoute
  '/settings/devices': typeof SettingsDevicesRoute
  '/settings/language': typeof SettingsLanguageRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/settings/offline': typeof SettingsOfflineRoute
  '/settings/privacy': typeof SettingsPrivacyRoute
  '/settings/profile': typeof SettingsProfileRoute
  '/settings/streak': typeof SettingsStreakRoute
  '/shared/$token': typeof SharedTokenRoute
  '/study-plan/$id': typeof StudyPlanIdRoute
  '/study-plan/calendar': typeof StudyPlanCalendarRoute
  '/study-plan/templates': typeof StudyPlanTemplatesRoute
  '/tutor/$sessionId': typeof TutorSessionIdRoute
  '/tutor/scenarios': typeof TutorScenariosRoute
  '/tutor/skills': typeof TutorSkillsRoute
  '/voice-tutor/new': typeof VoiceTutorNewRoute
  '/audio-recaps/': typeof AudioRecapsIndexRoute
  '/collections/': typeof CollectionsIndexRoute
  '/courses/': typeof CoursesIndexRoute
  '/flashcards/': typeof FlashcardsIndexRoute
  '/library/': typeof LibraryIndexRoute
  '/materials/': typeof MaterialsIndexRoute
  '/notes/': typeof NotesIndexRoute
  '/notifications/': typeof NotificationsIndexRoute
  '/onboarding/': typeof OnboardingIndexRoute
  '/recordings/': typeof RecordingsIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/study-plan/': typeof StudyPlanIndexRoute
  '/tests/': typeof TestsIndexRoute
  '/tutor/': typeof TutorIndexRoute
  '/voice-tutor/': typeof VoiceTutorIndexRoute
  '/audio-recaps/share/$token': typeof AudioRecapsShareTokenRoute
  '/billing/refund-status/$refundId': typeof BillingRefundStatusRefundIdRoute
  '/characters/sessions/$id': typeof CharactersSessionsIdRoute
  '/courses/catalog/$templateId': typeof CoursesCatalogTemplateIdRoute
  '/courses/templates/$templateId': typeof CoursesTemplatesTemplateIdRoute
  '/flashcards/sets/$setId': typeof FlashcardsSetsSetIdRoute
  '/flashcards/study/$setId': typeof FlashcardsStudySetIdRoute
  '/library/folders/$folderId': typeof LibraryFoldersFolderIdRoute
  '/materials/$materialId/notes': typeof MaterialsMaterialIdNotesRoute
  '/materials/sets/$setId': typeof MaterialsSetsSetIdRoute
  '/tests/edit/$id': typeof TestsEditIdRoute
  '/tests/results/$attemptId': typeof TestsResultsAttemptIdRoute
  '/tests/take/$id': typeof TestsTakeIdRoute
  '/tools/essay/$id': typeof ToolsEssayIdRoute
  '/tools/visual-explainer/$id': typeof ToolsVisualExplainerIdRoute
  '/tools/visuals/$id': typeof ToolsVisualsIdRoute
  '/voice-tutor/session/$id': typeof VoiceTutorSessionIdRoute
  '/library/folders/': typeof LibraryFoldersIndexRoute
  '/materials/sets/': typeof MaterialsSetsIndexRoute
  '/tools/essay/': typeof ToolsEssayIndexRoute
  '/tools/visual-explainer/': typeof ToolsVisualExplainerIndexRoute
  '/tools/visuals/': typeof ToolsVisualsIndexRoute
  '/courses/$courseId/topics/$topicId': typeof CoursesCourseIdTopicsTopicIdRoute
  '/study-plan/$id/subsection/$subId': typeof StudyPlanIdSubsectionSubIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/calendar': typeof CalendarRoute
  '/catalog': typeof CatalogRoute
  '/characters': typeof CharactersRoute
  '/faq': typeof FaqRoute
  '/favorites': typeof FavoritesRoute
  '/glossary': typeof GlossaryRoute
  '/impersonate': typeof ImpersonateRoute
  '/method': typeof MethodRoute
  '/offline': typeof OfflineRoute
  '/pricing': typeof PricingRoute
  '/progress': typeof ProgressRoute
  '/search': typeof SearchRoute
  '/trash': typeof TrashRoute
  '/weak-spots': typeof WeakSpotsRoute
  '/audio-recaps/$id': typeof AudioRecapsIdRoute
  '/audio-recaps/new': typeof AudioRecapsNewRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/login': typeof AuthLoginRoute
  '/billing/checkout': typeof BillingCheckoutRoute
  '/billing/success': typeof BillingSuccessRoute
  '/catalog/$slug': typeof CatalogSlugRoute
  '/collections/$setId': typeof CollectionsSetIdRoute
  '/courses/$courseId': typeof CoursesCourseIdRoute
  '/courses/calendar': typeof CoursesCalendarRoute
  '/courses/catalog': typeof CoursesCatalogRoute
  '/courses/new': typeof CoursesNewRoute
  '/courses/templates': typeof CoursesTemplatesRoute
  '/flashcards/marked': typeof FlashcardsMarkedRoute
  '/legal/$kind': typeof LegalKindRoute
  '/legal/accept': typeof LegalAcceptRoute
  '/materials/$materialId': typeof MaterialsMaterialIdRoute
  '/materials/trash': typeof MaterialsTrashRoute
  '/notes/$noteId': typeof NotesNoteIdRoute
  '/notifications/$id': typeof NotificationsIdRoute
  '/onboarding/done': typeof OnboardingDoneRoute
  '/onboarding/language': typeof OnboardingLanguageRoute
  '/onboarding/method': typeof OnboardingMethodRoute
  '/onboarding/rhythm': typeof OnboardingRhythmRoute
  '/recordings/$id': typeof RecordingsIdRoute
  '/recordings/new': typeof RecordingsNewRoute
  '/settings/account': typeof SettingsAccountRoute
  '/settings/appearance': typeof SettingsAppearanceRoute
  '/settings/billing': typeof SettingsBillingRoute
  '/settings/danger': typeof SettingsDangerRoute
  '/settings/devices': typeof SettingsDevicesRoute
  '/settings/language': typeof SettingsLanguageRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/settings/offline': typeof SettingsOfflineRoute
  '/settings/privacy': typeof SettingsPrivacyRoute
  '/settings/profile': typeof SettingsProfileRoute
  '/settings/streak': typeof SettingsStreakRoute
  '/shared/$token': typeof SharedTokenRoute
  '/study-plan/$id': typeof StudyPlanIdRoute
  '/study-plan/calendar': typeof StudyPlanCalendarRoute
  '/study-plan/templates': typeof StudyPlanTemplatesRoute
  '/tutor/$sessionId': typeof TutorSessionIdRoute
  '/tutor/scenarios': typeof TutorScenariosRoute
  '/tutor/skills': typeof TutorSkillsRoute
  '/voice-tutor/new': typeof VoiceTutorNewRoute
  '/audio-recaps': typeof AudioRecapsIndexRoute
  '/collections': typeof CollectionsIndexRoute
  '/courses': typeof CoursesIndexRoute
  '/flashcards': typeof FlashcardsIndexRoute
  '/library': typeof LibraryIndexRoute
  '/materials': typeof MaterialsIndexRoute
  '/notes': typeof NotesIndexRoute
  '/notifications': typeof NotificationsIndexRoute
  '/onboarding': typeof OnboardingIndexRoute
  '/recordings': typeof RecordingsIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/study-plan': typeof StudyPlanIndexRoute
  '/tests': typeof TestsIndexRoute
  '/tutor': typeof TutorIndexRoute
  '/voice-tutor': typeof VoiceTutorIndexRoute
  '/audio-recaps/share/$token': typeof AudioRecapsShareTokenRoute
  '/billing/refund-status/$refundId': typeof BillingRefundStatusRefundIdRoute
  '/characters/sessions/$id': typeof CharactersSessionsIdRoute
  '/courses/catalog/$templateId': typeof CoursesCatalogTemplateIdRoute
  '/courses/templates/$templateId': typeof CoursesTemplatesTemplateIdRoute
  '/flashcards/sets/$setId': typeof FlashcardsSetsSetIdRoute
  '/flashcards/study/$setId': typeof FlashcardsStudySetIdRoute
  '/library/folders/$folderId': typeof LibraryFoldersFolderIdRoute
  '/materials/$materialId/notes': typeof MaterialsMaterialIdNotesRoute
  '/materials/sets/$setId': typeof MaterialsSetsSetIdRoute
  '/tests/edit/$id': typeof TestsEditIdRoute
  '/tests/results/$attemptId': typeof TestsResultsAttemptIdRoute
  '/tests/take/$id': typeof TestsTakeIdRoute
  '/tools/essay/$id': typeof ToolsEssayIdRoute
  '/tools/visual-explainer/$id': typeof ToolsVisualExplainerIdRoute
  '/tools/visuals/$id': typeof ToolsVisualsIdRoute
  '/voice-tutor/session/$id': typeof VoiceTutorSessionIdRoute
  '/library/folders': typeof LibraryFoldersIndexRoute
  '/materials/sets': typeof MaterialsSetsIndexRoute
  '/tools/essay': typeof ToolsEssayIndexRoute
  '/tools/visual-explainer': typeof ToolsVisualExplainerIndexRoute
  '/tools/visuals': typeof ToolsVisualsIndexRoute
  '/courses/$courseId/topics/$topicId': typeof CoursesCourseIdTopicsTopicIdRoute
  '/study-plan/$id/subsection/$subId': typeof StudyPlanIdSubsectionSubIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/calendar': typeof CalendarRoute
  '/catalog': typeof CatalogRoute
  '/characters': typeof CharactersRoute
  '/faq': typeof FaqRoute
  '/favorites': typeof FavoritesRoute
  '/glossary': typeof GlossaryRoute
  '/impersonate': typeof ImpersonateRoute
  '/method': typeof MethodRoute
  '/offline': typeof OfflineRoute
  '/pricing': typeof PricingRoute
  '/progress': typeof ProgressRoute
  '/search': typeof SearchRoute
  '/settings': typeof SettingsRouteWithChildren
  '/trash': typeof TrashRoute
  '/weak-spots': typeof WeakSpotsRoute
  '/audio-recaps/$id': typeof AudioRecapsIdRoute
  '/audio-recaps/new': typeof AudioRecapsNewRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/login': typeof AuthLoginRoute
  '/billing/checkout': typeof BillingCheckoutRoute
  '/billing/success': typeof BillingSuccessRoute
  '/catalog_/$slug': typeof CatalogSlugRoute
  '/collections/$setId': typeof CollectionsSetIdRoute
  '/courses/$courseId': typeof CoursesCourseIdRoute
  '/courses/calendar': typeof CoursesCalendarRoute
  '/courses/catalog': typeof CoursesCatalogRoute
  '/courses/new': typeof CoursesNewRoute
  '/courses/templates': typeof CoursesTemplatesRoute
  '/flashcards/marked': typeof FlashcardsMarkedRoute
  '/legal/$kind': typeof LegalKindRoute
  '/legal/accept': typeof LegalAcceptRoute
  '/materials/$materialId': typeof MaterialsMaterialIdRoute
  '/materials/trash': typeof MaterialsTrashRoute
  '/notes/$noteId': typeof NotesNoteIdRoute
  '/notifications/$id': typeof NotificationsIdRoute
  '/onboarding/done': typeof OnboardingDoneRoute
  '/onboarding/language': typeof OnboardingLanguageRoute
  '/onboarding/method': typeof OnboardingMethodRoute
  '/onboarding/rhythm': typeof OnboardingRhythmRoute
  '/recordings/$id': typeof RecordingsIdRoute
  '/recordings/new': typeof RecordingsNewRoute
  '/settings/account': typeof SettingsAccountRoute
  '/settings/appearance': typeof SettingsAppearanceRoute
  '/settings/billing': typeof SettingsBillingRoute
  '/settings/danger': typeof SettingsDangerRoute
  '/settings/devices': typeof SettingsDevicesRoute
  '/settings/language': typeof SettingsLanguageRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/settings/offline': typeof SettingsOfflineRoute
  '/settings/privacy': typeof SettingsPrivacyRoute
  '/settings/profile': typeof SettingsProfileRoute
  '/settings/streak': typeof SettingsStreakRoute
  '/shared/$token': typeof SharedTokenRoute
  '/study-plan/$id': typeof StudyPlanIdRoute
  '/study-plan/calendar': typeof StudyPlanCalendarRoute
  '/study-plan/templates': typeof StudyPlanTemplatesRoute
  '/tutor/$sessionId': typeof TutorSessionIdRoute
  '/tutor/scenarios': typeof TutorScenariosRoute
  '/tutor/skills': typeof TutorSkillsRoute
  '/voice-tutor/new': typeof VoiceTutorNewRoute
  '/audio-recaps/': typeof AudioRecapsIndexRoute
  '/collections/': typeof CollectionsIndexRoute
  '/courses/': typeof CoursesIndexRoute
  '/flashcards/': typeof FlashcardsIndexRoute
  '/library/': typeof LibraryIndexRoute
  '/materials/': typeof MaterialsIndexRoute
  '/notes/': typeof NotesIndexRoute
  '/notifications/': typeof NotificationsIndexRoute
  '/onboarding/': typeof OnboardingIndexRoute
  '/recordings/': typeof RecordingsIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/study-plan/': typeof StudyPlanIndexRoute
  '/tests/': typeof TestsIndexRoute
  '/tutor/': typeof TutorIndexRoute
  '/voice-tutor/': typeof VoiceTutorIndexRoute
  '/audio-recaps/share/$token': typeof AudioRecapsShareTokenRoute
  '/billing/refund-status/$refundId': typeof BillingRefundStatusRefundIdRoute
  '/characters_/sessions/$id': typeof CharactersSessionsIdRoute
  '/courses/catalog_/$templateId': typeof CoursesCatalogTemplateIdRoute
  '/courses/templates_/$templateId': typeof CoursesTemplatesTemplateIdRoute
  '/flashcards/sets/$setId': typeof FlashcardsSetsSetIdRoute
  '/flashcards/study/$setId': typeof FlashcardsStudySetIdRoute
  '/library/folders/$folderId': typeof LibraryFoldersFolderIdRoute
  '/materials/$materialId_/notes': typeof MaterialsMaterialIdNotesRoute
  '/materials/sets/$setId': typeof MaterialsSetsSetIdRoute
  '/tests/edit/$id': typeof TestsEditIdRoute
  '/tests/results/$attemptId': typeof TestsResultsAttemptIdRoute
  '/tests/take/$id': typeof TestsTakeIdRoute
  '/tools/essay/$id': typeof ToolsEssayIdRoute
  '/tools/visual-explainer/$id': typeof ToolsVisualExplainerIdRoute
  '/tools/visuals/$id': typeof ToolsVisualsIdRoute
  '/voice-tutor/session/$id': typeof VoiceTutorSessionIdRoute
  '/library/folders/': typeof LibraryFoldersIndexRoute
  '/materials/sets/': typeof MaterialsSetsIndexRoute
  '/tools/essay/': typeof ToolsEssayIndexRoute
  '/tools/visual-explainer/': typeof ToolsVisualExplainerIndexRoute
  '/tools/visuals/': typeof ToolsVisualsIndexRoute
  '/courses/$courseId_/topics/$topicId': typeof CoursesCourseIdTopicsTopicIdRoute
  '/study-plan/$id_/subsection/$subId': typeof StudyPlanIdSubsectionSubIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/calendar'
    | '/catalog'
    | '/characters'
    | '/faq'
    | '/favorites'
    | '/glossary'
    | '/impersonate'
    | '/method'
    | '/offline'
    | '/pricing'
    | '/progress'
    | '/search'
    | '/settings'
    | '/trash'
    | '/weak-spots'
    | '/audio-recaps/$id'
    | '/audio-recaps/new'
    | '/auth/callback'
    | '/auth/login'
    | '/billing/checkout'
    | '/billing/success'
    | '/catalog/$slug'
    | '/collections/$setId'
    | '/courses/$courseId'
    | '/courses/calendar'
    | '/courses/catalog'
    | '/courses/new'
    | '/courses/templates'
    | '/flashcards/marked'
    | '/legal/$kind'
    | '/legal/accept'
    | '/materials/$materialId'
    | '/materials/trash'
    | '/notes/$noteId'
    | '/notifications/$id'
    | '/onboarding/done'
    | '/onboarding/language'
    | '/onboarding/method'
    | '/onboarding/rhythm'
    | '/recordings/$id'
    | '/recordings/new'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/billing'
    | '/settings/danger'
    | '/settings/devices'
    | '/settings/language'
    | '/settings/notifications'
    | '/settings/offline'
    | '/settings/privacy'
    | '/settings/profile'
    | '/settings/streak'
    | '/shared/$token'
    | '/study-plan/$id'
    | '/study-plan/calendar'
    | '/study-plan/templates'
    | '/tutor/$sessionId'
    | '/tutor/scenarios'
    | '/tutor/skills'
    | '/voice-tutor/new'
    | '/audio-recaps/'
    | '/collections/'
    | '/courses/'
    | '/flashcards/'
    | '/library/'
    | '/materials/'
    | '/notes/'
    | '/notifications/'
    | '/onboarding/'
    | '/recordings/'
    | '/settings/'
    | '/study-plan/'
    | '/tests/'
    | '/tutor/'
    | '/voice-tutor/'
    | '/audio-recaps/share/$token'
    | '/billing/refund-status/$refundId'
    | '/characters/sessions/$id'
    | '/courses/catalog/$templateId'
    | '/courses/templates/$templateId'
    | '/flashcards/sets/$setId'
    | '/flashcards/study/$setId'
    | '/library/folders/$folderId'
    | '/materials/$materialId/notes'
    | '/materials/sets/$setId'
    | '/tests/edit/$id'
    | '/tests/results/$attemptId'
    | '/tests/take/$id'
    | '/tools/essay/$id'
    | '/tools/visual-explainer/$id'
    | '/tools/visuals/$id'
    | '/voice-tutor/session/$id'
    | '/library/folders/'
    | '/materials/sets/'
    | '/tools/essay/'
    | '/tools/visual-explainer/'
    | '/tools/visuals/'
    | '/courses/$courseId/topics/$topicId'
    | '/study-plan/$id/subsection/$subId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/calendar'
    | '/catalog'
    | '/characters'
    | '/faq'
    | '/favorites'
    | '/glossary'
    | '/impersonate'
    | '/method'
    | '/offline'
    | '/pricing'
    | '/progress'
    | '/search'
    | '/trash'
    | '/weak-spots'
    | '/audio-recaps/$id'
    | '/audio-recaps/new'
    | '/auth/callback'
    | '/auth/login'
    | '/billing/checkout'
    | '/billing/success'
    | '/catalog/$slug'
    | '/collections/$setId'
    | '/courses/$courseId'
    | '/courses/calendar'
    | '/courses/catalog'
    | '/courses/new'
    | '/courses/templates'
    | '/flashcards/marked'
    | '/legal/$kind'
    | '/legal/accept'
    | '/materials/$materialId'
    | '/materials/trash'
    | '/notes/$noteId'
    | '/notifications/$id'
    | '/onboarding/done'
    | '/onboarding/language'
    | '/onboarding/method'
    | '/onboarding/rhythm'
    | '/recordings/$id'
    | '/recordings/new'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/billing'
    | '/settings/danger'
    | '/settings/devices'
    | '/settings/language'
    | '/settings/notifications'
    | '/settings/offline'
    | '/settings/privacy'
    | '/settings/profile'
    | '/settings/streak'
    | '/shared/$token'
    | '/study-plan/$id'
    | '/study-plan/calendar'
    | '/study-plan/templates'
    | '/tutor/$sessionId'
    | '/tutor/scenarios'
    | '/tutor/skills'
    | '/voice-tutor/new'
    | '/audio-recaps'
    | '/collections'
    | '/courses'
    | '/flashcards'
    | '/library'
    | '/materials'
    | '/notes'
    | '/notifications'
    | '/onboarding'
    | '/recordings'
    | '/settings'
    | '/study-plan'
    | '/tests'
    | '/tutor'
    | '/voice-tutor'
    | '/audio-recaps/share/$token'
    | '/billing/refund-status/$refundId'
    | '/characters/sessions/$id'
    | '/courses/catalog/$templateId'
    | '/courses/templates/$templateId'
    | '/flashcards/sets/$setId'
    | '/flashcards/study/$setId'
    | '/library/folders/$folderId'
    | '/materials/$materialId/notes'
    | '/materials/sets/$setId'
    | '/tests/edit/$id'
    | '/tests/results/$attemptId'
    | '/tests/take/$id'
    | '/tools/essay/$id'
    | '/tools/visual-explainer/$id'
    | '/tools/visuals/$id'
    | '/voice-tutor/session/$id'
    | '/library/folders'
    | '/materials/sets'
    | '/tools/essay'
    | '/tools/visual-explainer'
    | '/tools/visuals'
    | '/courses/$courseId/topics/$topicId'
    | '/study-plan/$id/subsection/$subId'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/calendar'
    | '/catalog'
    | '/characters'
    | '/faq'
    | '/favorites'
    | '/glossary'
    | '/impersonate'
    | '/method'
    | '/offline'
    | '/pricing'
    | '/progress'
    | '/search'
    | '/settings'
    | '/trash'
    | '/weak-spots'
    | '/audio-recaps/$id'
    | '/audio-recaps/new'
    | '/auth/callback'
    | '/auth/login'
    | '/billing/checkout'
    | '/billing/success'
    | '/catalog_/$slug'
    | '/collections/$setId'
    | '/courses/$courseId'
    | '/courses/calendar'
    | '/courses/catalog'
    | '/courses/new'
    | '/courses/templates'
    | '/flashcards/marked'
    | '/legal/$kind'
    | '/legal/accept'
    | '/materials/$materialId'
    | '/materials/trash'
    | '/notes/$noteId'
    | '/notifications/$id'
    | '/onboarding/done'
    | '/onboarding/language'
    | '/onboarding/method'
    | '/onboarding/rhythm'
    | '/recordings/$id'
    | '/recordings/new'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/billing'
    | '/settings/danger'
    | '/settings/devices'
    | '/settings/language'
    | '/settings/notifications'
    | '/settings/offline'
    | '/settings/privacy'
    | '/settings/profile'
    | '/settings/streak'
    | '/shared/$token'
    | '/study-plan/$id'
    | '/study-plan/calendar'
    | '/study-plan/templates'
    | '/tutor/$sessionId'
    | '/tutor/scenarios'
    | '/tutor/skills'
    | '/voice-tutor/new'
    | '/audio-recaps/'
    | '/collections/'
    | '/courses/'
    | '/flashcards/'
    | '/library/'
    | '/materials/'
    | '/notes/'
    | '/notifications/'
    | '/onboarding/'
    | '/recordings/'
    | '/settings/'
    | '/study-plan/'
    | '/tests/'
    | '/tutor/'
    | '/voice-tutor/'
    | '/audio-recaps/share/$token'
    | '/billing/refund-status/$refundId'
    | '/characters_/sessions/$id'
    | '/courses/catalog_/$templateId'
    | '/courses/templates_/$templateId'
    | '/flashcards/sets/$setId'
    | '/flashcards/study/$setId'
    | '/library/folders/$folderId'
    | '/materials/$materialId_/notes'
    | '/materials/sets/$setId'
    | '/tests/edit/$id'
    | '/tests/results/$attemptId'
    | '/tests/take/$id'
    | '/tools/essay/$id'
    | '/tools/visual-explainer/$id'
    | '/tools/visuals/$id'
    | '/voice-tutor/session/$id'
    | '/library/folders/'
    | '/materials/sets/'
    | '/tools/essay/'
    | '/tools/visual-explainer/'
    | '/tools/visuals/'
    | '/courses/$courseId_/topics/$topicId'
    | '/study-plan/$id_/subsection/$subId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  CalendarRoute: typeof CalendarRoute
  CatalogRoute: typeof CatalogRoute
  CharactersRoute: typeof CharactersRoute
  FaqRoute: typeof FaqRoute
  FavoritesRoute: typeof FavoritesRoute
  GlossaryRoute: typeof GlossaryRoute
  ImpersonateRoute: typeof ImpersonateRoute
  MethodRoute: typeof MethodRoute
  OfflineRoute: typeof OfflineRoute
  PricingRoute: typeof PricingRoute
  ProgressRoute: typeof ProgressRoute
  SearchRoute: typeof SearchRoute
  SettingsRoute: typeof SettingsRouteWithChildren
  TrashRoute: typeof TrashRoute
  WeakSpotsRoute: typeof WeakSpotsRoute
  AudioRecapsIdRoute: typeof AudioRecapsIdRoute
  AudioRecapsNewRoute: typeof AudioRecapsNewRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  AuthLoginRoute: typeof AuthLoginRoute
  BillingCheckoutRoute: typeof BillingCheckoutRoute
  BillingSuccessRoute: typeof BillingSuccessRoute
  CatalogSlugRoute: typeof CatalogSlugRoute
  CollectionsSetIdRoute: typeof CollectionsSetIdRoute
  CoursesCourseIdRoute: typeof CoursesCourseIdRoute
  CoursesCalendarRoute: typeof CoursesCalendarRoute
  CoursesCatalogRoute: typeof CoursesCatalogRoute
  CoursesNewRoute: typeof CoursesNewRoute
  CoursesTemplatesRoute: typeof CoursesTemplatesRoute
  FlashcardsMarkedRoute: typeof FlashcardsMarkedRoute
  LegalKindRoute: typeof LegalKindRoute
  LegalAcceptRoute: typeof LegalAcceptRoute
  MaterialsMaterialIdRoute: typeof MaterialsMaterialIdRoute
  MaterialsTrashRoute: typeof MaterialsTrashRoute
  NotesNoteIdRoute: typeof NotesNoteIdRoute
  NotificationsIdRoute: typeof NotificationsIdRoute
  OnboardingDoneRoute: typeof OnboardingDoneRoute
  OnboardingLanguageRoute: typeof OnboardingLanguageRoute
  OnboardingMethodRoute: typeof OnboardingMethodRoute
  OnboardingRhythmRoute: typeof OnboardingRhythmRoute
  RecordingsIdRoute: typeof RecordingsIdRoute
  RecordingsNewRoute: typeof RecordingsNewRoute
  SharedTokenRoute: typeof SharedTokenRoute
  StudyPlanIdRoute: typeof StudyPlanIdRoute
  StudyPlanCalendarRoute: typeof StudyPlanCalendarRoute
  StudyPlanTemplatesRoute: typeof StudyPlanTemplatesRoute
  TutorSessionIdRoute: typeof TutorSessionIdRoute
  TutorScenariosRoute: typeof TutorScenariosRoute
  TutorSkillsRoute: typeof TutorSkillsRoute
  VoiceTutorNewRoute: typeof VoiceTutorNewRoute
  AudioRecapsIndexRoute: typeof AudioRecapsIndexRoute
  CollectionsIndexRoute: typeof CollectionsIndexRoute
  CoursesIndexRoute: typeof CoursesIndexRoute
  FlashcardsIndexRoute: typeof FlashcardsIndexRoute
  LibraryIndexRoute: typeof LibraryIndexRoute
  MaterialsIndexRoute: typeof MaterialsIndexRoute
  NotesIndexRoute: typeof NotesIndexRoute
  NotificationsIndexRoute: typeof NotificationsIndexRoute
  OnboardingIndexRoute: typeof OnboardingIndexRoute
  RecordingsIndexRoute: typeof RecordingsIndexRoute
  StudyPlanIndexRoute: typeof StudyPlanIndexRoute
  TestsIndexRoute: typeof TestsIndexRoute
  TutorIndexRoute: typeof TutorIndexRoute
  VoiceTutorIndexRoute: typeof VoiceTutorIndexRoute
  AudioRecapsShareTokenRoute: typeof AudioRecapsShareTokenRoute
  BillingRefundStatusRefundIdRoute: typeof BillingRefundStatusRefundIdRoute
  CharactersSessionsIdRoute: typeof CharactersSessionsIdRoute
  CoursesCatalogTemplateIdRoute: typeof CoursesCatalogTemplateIdRoute
  CoursesTemplatesTemplateIdRoute: typeof CoursesTemplatesTemplateIdRoute
  FlashcardsSetsSetIdRoute: typeof FlashcardsSetsSetIdRoute
  FlashcardsStudySetIdRoute: typeof FlashcardsStudySetIdRoute
  LibraryFoldersFolderIdRoute: typeof LibraryFoldersFolderIdRoute
  MaterialsMaterialIdNotesRoute: typeof MaterialsMaterialIdNotesRoute
  MaterialsSetsSetIdRoute: typeof MaterialsSetsSetIdRoute
  TestsEditIdRoute: typeof TestsEditIdRoute
  TestsResultsAttemptIdRoute: typeof TestsResultsAttemptIdRoute
  TestsTakeIdRoute: typeof TestsTakeIdRoute
  ToolsEssayIdRoute: typeof ToolsEssayIdRoute
  ToolsVisualExplainerIdRoute: typeof ToolsVisualExplainerIdRoute
  ToolsVisualsIdRoute: typeof ToolsVisualsIdRoute
  VoiceTutorSessionIdRoute: typeof VoiceTutorSessionIdRoute
  LibraryFoldersIndexRoute: typeof LibraryFoldersIndexRoute
  MaterialsSetsIndexRoute: typeof MaterialsSetsIndexRoute
  ToolsEssayIndexRoute: typeof ToolsEssayIndexRoute
  ToolsVisualExplainerIndexRoute: typeof ToolsVisualExplainerIndexRoute
  ToolsVisualsIndexRoute: typeof ToolsVisualsIndexRoute
  CoursesCourseIdTopicsTopicIdRoute: typeof CoursesCourseIdTopicsTopicIdRoute
  StudyPlanIdSubsectionSubIdRoute: typeof StudyPlanIdSubsectionSubIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calendar': {
      id: '/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof CalendarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog': {
      id: '/catalog'
      path: '/catalog'
      fullPath: '/catalog'
      preLoaderRoute: typeof CatalogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/characters': {
      id: '/characters'
      path: '/characters'
      fullPath: '/characters'
      preLoaderRoute: typeof CharactersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/faq': {
      id: '/faq'
      path: '/faq'
      fullPath: '/faq'
      preLoaderRoute: typeof FaqRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/favorites': {
      id: '/favorites'
      path: '/favorites'
      fullPath: '/favorites'
      preLoaderRoute: typeof FavoritesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/glossary': {
      id: '/glossary'
      path: '/glossary'
      fullPath: '/glossary'
      preLoaderRoute: typeof GlossaryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/impersonate': {
      id: '/impersonate'
      path: '/impersonate'
      fullPath: '/impersonate'
      preLoaderRoute: typeof ImpersonateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/method': {
      id: '/method'
      path: '/method'
      fullPath: '/method'
      preLoaderRoute: typeof MethodRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/offline': {
      id: '/offline'
      path: '/offline'
      fullPath: '/offline'
      preLoaderRoute: typeof OfflineRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pricing': {
      id: '/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/progress': {
      id: '/progress'
      path: '/progress'
      fullPath: '/progress'
      preLoaderRoute: typeof ProgressRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/search': {
      id: '/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof SearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trash': {
      id: '/trash'
      path: '/trash'
      fullPath: '/trash'
      preLoaderRoute: typeof TrashRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/weak-spots': {
      id: '/weak-spots'
      path: '/weak-spots'
      fullPath: '/weak-spots'
      preLoaderRoute: typeof WeakSpotsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audio-recaps/': {
      id: '/audio-recaps/'
      path: '/audio-recaps'
      fullPath: '/audio-recaps/'
      preLoaderRoute: typeof AudioRecapsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audio-recaps/$id': {
      id: '/audio-recaps/$id'
      path: '/audio-recaps/$id'
      fullPath: '/audio-recaps/$id'
      preLoaderRoute: typeof AudioRecapsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audio-recaps/new': {
      id: '/audio-recaps/new'
      path: '/audio-recaps/new'
      fullPath: '/audio-recaps/new'
      preLoaderRoute: typeof AudioRecapsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing/checkout': {
      id: '/billing/checkout'
      path: '/billing/checkout'
      fullPath: '/billing/checkout'
      preLoaderRoute: typeof BillingCheckoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing/success': {
      id: '/billing/success'
      path: '/billing/success'
      fullPath: '/billing/success'
      preLoaderRoute: typeof BillingSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog_/$slug': {
      id: '/catalog_/$slug'
      path: '/catalog/$slug'
      fullPath: '/catalog/$slug'
      preLoaderRoute: typeof CatalogSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/collections/': {
      id: '/collections/'
      path: '/collections'
      fullPath: '/collections/'
      preLoaderRoute: typeof CollectionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/collections/$setId': {
      id: '/collections/$setId'
      path: '/collections/$setId'
      fullPath: '/collections/$setId'
      preLoaderRoute: typeof CollectionsSetIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/courses/': {
      id: '/courses/'
      path: '/courses'
      fullPath: '/courses/'
      preLoaderRoute: typeof CoursesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/courses/$courseId': {
      id: '/courses/$courseId'
      path: '/courses/$courseId'
      fullPath: '/courses/$courseId'
      preLoaderRoute: typeof CoursesCourseIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/courses/calendar': {
      id: '/courses/calendar'
      path: '/courses/calendar'
      fullPath: '/courses/calendar'
      preLoaderRoute: typeof CoursesCalendarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/courses/catalog': {
      id: '/courses/catalog'
      path: '/courses/catalog'
      fullPath: '/courses/catalog'
      preLoaderRoute: typeof CoursesCatalogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/courses/new': {
      id: '/courses/new'
      path: '/courses/new'
      fullPath: '/courses/new'
      preLoaderRoute: typeof CoursesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/courses/templates': {
      id: '/courses/templates'
      path: '/courses/templates'
      fullPath: '/courses/templates'
      preLoaderRoute: typeof CoursesTemplatesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/flashcards/': {
      id: '/flashcards/'
      path: '/flashcards'
      fullPath: '/flashcards/'
      preLoaderRoute: typeof FlashcardsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/flashcards/marked': {
      id: '/flashcards/marked'
      path: '/flashcards/marked'
      fullPath: '/flashcards/marked'
      preLoaderRoute: typeof FlashcardsMarkedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal/$kind': {
      id: '/legal/$kind'
      path: '/legal/$kind'
      fullPath: '/legal/$kind'
      preLoaderRoute: typeof LegalKindRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal/accept': {
      id: '/legal/accept'
      path: '/legal/accept'
      fullPath: '/legal/accept'
      preLoaderRoute: typeof LegalAcceptRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/library/': {
      id: '/library/'
      path: '/library'
      fullPath: '/library/'
      preLoaderRoute: typeof LibraryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/materials/': {
      id: '/materials/'
      path: '/materials'
      fullPath: '/materials/'
      preLoaderRoute: typeof MaterialsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/materials/$materialId': {
      id: '/materials/$materialId'
      path: '/materials/$materialId'
      fullPath: '/materials/$materialId'
      preLoaderRoute: typeof MaterialsMaterialIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/materials/trash': {
      id: '/materials/trash'
      path: '/materials/trash'
      fullPath: '/materials/trash'
      preLoaderRoute: typeof MaterialsTrashRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notes/': {
      id: '/notes/'
      path: '/notes'
      fullPath: '/notes/'
      preLoaderRoute: typeof NotesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notes/$noteId': {
      id: '/notes/$noteId'
      path: '/notes/$noteId'
      fullPath: '/notes/$noteId'
      preLoaderRoute: typeof NotesNoteIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications/': {
      id: '/notifications/'
      path: '/notifications'
      fullPath: '/notifications/'
      preLoaderRoute: typeof NotificationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications/$id': {
      id: '/notifications/$id'
      path: '/notifications/$id'
      fullPath: '/notifications/$id'
      preLoaderRoute: typeof NotificationsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/': {
      id: '/onboarding/'
      path: '/onboarding'
      fullPath: '/onboarding/'
      preLoaderRoute: typeof OnboardingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/done': {
      id: '/onboarding/done'
      path: '/onboarding/done'
      fullPath: '/onboarding/done'
      preLoaderRoute: typeof OnboardingDoneRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/language': {
      id: '/onboarding/language'
      path: '/onboarding/language'
      fullPath: '/onboarding/language'
      preLoaderRoute: typeof OnboardingLanguageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/method': {
      id: '/onboarding/method'
      path: '/onboarding/method'
      fullPath: '/onboarding/method'
      preLoaderRoute: typeof OnboardingMethodRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/rhythm': {
      id: '/onboarding/rhythm'
      path: '/onboarding/rhythm'
      fullPath: '/onboarding/rhythm'
      preLoaderRoute: typeof OnboardingRhythmRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recordings/': {
      id: '/recordings/'
      path: '/recordings'
      fullPath: '/recordings/'
      preLoaderRoute: typeof RecordingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recordings/$id': {
      id: '/recordings/$id'
      path: '/recordings/$id'
      fullPath: '/recordings/$id'
      preLoaderRoute: typeof RecordingsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recordings/new': {
      id: '/recordings/new'
      path: '/recordings/new'
      fullPath: '/recordings/new'
      preLoaderRoute: typeof RecordingsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/account': {
      id: '/settings/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof SettingsAccountRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/appearance': {
      id: '/settings/appearance'
      path: '/appearance'
      fullPath: '/settings/appearance'
      preLoaderRoute: typeof SettingsAppearanceRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/billing': {
      id: '/settings/billing'
      path: '/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof SettingsBillingRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/danger': {
      id: '/settings/danger'
      path: '/danger'
      fullPath: '/settings/danger'
      preLoaderRoute: typeof SettingsDangerRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/devices': {
      id: '/settings/devices'
      path: '/devices'
      fullPath: '/settings/devices'
      preLoaderRoute: typeof SettingsDevicesRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/language': {
      id: '/settings/language'
      path: '/language'
      fullPath: '/settings/language'
      preLoaderRoute: typeof SettingsLanguageRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/notifications': {
      id: '/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof SettingsNotificationsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/offline': {
      id: '/settings/offline'
      path: '/offline'
      fullPath: '/settings/offline'
      preLoaderRoute: typeof SettingsOfflineRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/privacy': {
      id: '/settings/privacy'
      path: '/privacy'
      fullPath: '/settings/privacy'
      preLoaderRoute: typeof SettingsPrivacyRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/profile': {
      id: '/settings/profile'
      path: '/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof SettingsProfileRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/streak': {
      id: '/settings/streak'
      path: '/streak'
      fullPath: '/settings/streak'
      preLoaderRoute: typeof SettingsStreakRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/shared/$token': {
      id: '/shared/$token'
      path: '/shared/$token'
      fullPath: '/shared/$token'
      preLoaderRoute: typeof SharedTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/study-plan/': {
      id: '/study-plan/'
      path: '/study-plan'
      fullPath: '/study-plan/'
      preLoaderRoute: typeof StudyPlanIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/study-plan/$id': {
      id: '/study-plan/$id'
      path: '/study-plan/$id'
      fullPath: '/study-plan/$id'
      preLoaderRoute: typeof StudyPlanIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/study-plan/calendar': {
      id: '/study-plan/calendar'
      path: '/study-plan/calendar'
      fullPath: '/study-plan/calendar'
      preLoaderRoute: typeof StudyPlanCalendarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/study-plan/templates': {
      id: '/study-plan/templates'
      path: '/study-plan/templates'
      fullPath: '/study-plan/templates'
      preLoaderRoute: typeof StudyPlanTemplatesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tests/': {
      id: '/tests/'
      path: '/tests'
      fullPath: '/tests/'
      preLoaderRoute: typeof TestsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tutor/': {
      id: '/tutor/'
      path: '/tutor'
      fullPath: '/tutor/'
      preLoaderRoute: typeof TutorIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tutor/$sessionId': {
      id: '/tutor/$sessionId'
      path: '/tutor/$sessionId'
      fullPath: '/tutor/$sessionId'
      preLoaderRoute: typeof TutorSessionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tutor/scenarios': {
      id: '/tutor/scenarios'
      path: '/tutor/scenarios'
      fullPath: '/tutor/scenarios'
      preLoaderRoute: typeof TutorScenariosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tutor/skills': {
      id: '/tutor/skills'
      path: '/tutor/skills'
      fullPath: '/tutor/skills'
      preLoaderRoute: typeof TutorSkillsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/voice-tutor/': {
      id: '/voice-tutor/'
      path: '/voice-tutor'
      fullPath: '/voice-tutor/'
      preLoaderRoute: typeof VoiceTutorIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/voice-tutor/new': {
      id: '/voice-tutor/new'
      path: '/voice-tutor/new'
      fullPath: '/voice-tutor/new'
      preLoaderRoute: typeof VoiceTutorNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audio-recaps/share/$token': {
      id: '/audio-recaps/share/$token'
      path: '/audio-recaps/share/$token'
      fullPath: '/audio-recaps/share/$token'
      preLoaderRoute: typeof AudioRecapsShareTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing/refund-status/$refundId': {
      id: '/billing/refund-status/$refundId'
      path: '/billing/refund-status/$refundId'
      fullPath: '/billing/refund-status/$refundId'
      preLoaderRoute: typeof BillingRefundStatusRefundIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/characters_/sessions/$id': {
      id: '/characters_/sessions/$id'
      path: '/characters/sessions/$id'
      fullPath: '/characters/sessions/$id'
      preLoaderRoute: typeof CharactersSessionsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/courses/catalog_/$templateId': {
      id: '/courses/catalog_/$templateId'
      path: '/courses/catalog/$templateId'
      fullPath: '/courses/catalog/$templateId'
      preLoaderRoute: typeof CoursesCatalogTemplateIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/courses/templates_/$templateId': {
      id: '/courses/templates_/$templateId'
      path: '/courses/templates/$templateId'
      fullPath: '/courses/templates/$templateId'
      preLoaderRoute: typeof CoursesTemplatesTemplateIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/flashcards/sets/$setId': {
      id: '/flashcards/sets/$setId'
      path: '/flashcards/sets/$setId'
      fullPath: '/flashcards/sets/$setId'
      preLoaderRoute: typeof FlashcardsSetsSetIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/flashcards/study/$setId': {
      id: '/flashcards/study/$setId'
      path: '/flashcards/study/$setId'
      fullPath: '/flashcards/study/$setId'
      preLoaderRoute: typeof FlashcardsStudySetIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/library/folders/': {
      id: '/library/folders/'
      path: '/library/folders'
      fullPath: '/library/folders/'
      preLoaderRoute: typeof LibraryFoldersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/library/folders/$folderId': {
      id: '/library/folders/$folderId'
      path: '/library/folders/$folderId'
      fullPath: '/library/folders/$folderId'
      preLoaderRoute: typeof LibraryFoldersFolderIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/materials/$materialId_/notes': {
      id: '/materials/$materialId_/notes'
      path: '/materials/$materialId/notes'
      fullPath: '/materials/$materialId/notes'
      preLoaderRoute: typeof MaterialsMaterialIdNotesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/materials/sets/': {
      id: '/materials/sets/'
      path: '/materials/sets'
      fullPath: '/materials/sets/'
      preLoaderRoute: typeof MaterialsSetsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/materials/sets/$setId': {
      id: '/materials/sets/$setId'
      path: '/materials/sets/$setId'
      fullPath: '/materials/sets/$setId'
      preLoaderRoute: typeof MaterialsSetsSetIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tests/edit/$id': {
      id: '/tests/edit/$id'
      path: '/tests/edit/$id'
      fullPath: '/tests/edit/$id'
      preLoaderRoute: typeof TestsEditIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tests/results/$attemptId': {
      id: '/tests/results/$attemptId'
      path: '/tests/results/$attemptId'
      fullPath: '/tests/results/$attemptId'
      preLoaderRoute: typeof TestsResultsAttemptIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tests/take/$id': {
      id: '/tests/take/$id'
      path: '/tests/take/$id'
      fullPath: '/tests/take/$id'
      preLoaderRoute: typeof TestsTakeIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tools/essay/': {
      id: '/tools/essay/'
      path: '/tools/essay'
      fullPath: '/tools/essay/'
      preLoaderRoute: typeof ToolsEssayIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tools/essay/$id': {
      id: '/tools/essay/$id'
      path: '/tools/essay/$id'
      fullPath: '/tools/essay/$id'
      preLoaderRoute: typeof ToolsEssayIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tools/visual-explainer/': {
      id: '/tools/visual-explainer/'
      path: '/tools/visual-explainer'
      fullPath: '/tools/visual-explainer/'
      preLoaderRoute: typeof ToolsVisualExplainerIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tools/visual-explainer/$id': {
      id: '/tools/visual-explainer/$id'
      path: '/tools/visual-explainer/$id'
      fullPath: '/tools/visual-explainer/$id'
      preLoaderRoute: typeof ToolsVisualExplainerIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tools/visuals/': {
      id: '/tools/visuals/'
      path: '/tools/visuals'
      fullPath: '/tools/visuals/'
      preLoaderRoute: typeof ToolsVisualsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tools/visuals/$id': {
      id: '/tools/visuals/$id'
      path: '/tools/visuals/$id'
      fullPath: '/tools/visuals/$id'
      preLoaderRoute: typeof ToolsVisualsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/voice-tutor/session/$id': {
      id: '/voice-tutor/session/$id'
      path: '/voice-tutor/session/$id'
      fullPath: '/voice-tutor/session/$id'
      preLoaderRoute: typeof VoiceTutorSessionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/courses/$courseId_/topics/$topicId': {
      id: '/courses/$courseId_/topics/$topicId'
      path: '/courses/$courseId/topics/$topicId'
      fullPath: '/courses/$courseId/topics/$topicId'
      preLoaderRoute: typeof CoursesCourseIdTopicsTopicIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/study-plan/$id_/subsection/$subId': {
      id: '/study-plan/$id_/subsection/$subId'
      path: '/study-plan/$id/subsection/$subId'
      fullPath: '/study-plan/$id/subsection/$subId'
      preLoaderRoute: typeof StudyPlanIdSubsectionSubIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface SettingsRouteChildren {
  SettingsAccountRoute: typeof SettingsAccountRoute
  SettingsAppearanceRoute: typeof SettingsAppearanceRoute
  SettingsBillingRoute: typeof SettingsBillingRoute
  SettingsDangerRoute: typeof SettingsDangerRoute
  SettingsDevicesRoute: typeof SettingsDevicesRoute
  SettingsLanguageRoute: typeof SettingsLanguageRoute
  SettingsNotificationsRoute: typeof SettingsNotificationsRoute
  SettingsOfflineRoute: typeof SettingsOfflineRoute
  SettingsPrivacyRoute: typeof SettingsPrivacyRoute
  SettingsProfileRoute: typeof SettingsProfileRoute
  SettingsStreakRoute: typeof SettingsStreakRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
}

const SettingsRouteChildren: SettingsRouteChildren = {
  SettingsAccountRoute: SettingsAccountRoute,
  SettingsAppearanceRoute: SettingsAppearanceRoute,
  SettingsBillingRoute: SettingsBillingRoute,
  SettingsDangerRoute: SettingsDangerRoute,
  SettingsDevicesRoute: SettingsDevicesRoute,
  SettingsLanguageRoute: SettingsLanguageRoute,
  SettingsNotificationsRoute: SettingsNotificationsRoute,
  SettingsOfflineRoute: SettingsOfflineRoute,
  SettingsPrivacyRoute: SettingsPrivacyRoute,
  SettingsProfileRoute: SettingsProfileRoute,
  SettingsStreakRoute: SettingsStreakRoute,
  SettingsIndexRoute: SettingsIndexRoute,
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(
  SettingsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  CalendarRoute: CalendarRoute,
  CatalogRoute: CatalogRoute,
  CharactersRoute: CharactersRoute,
  FaqRoute: FaqRoute,
  FavoritesRoute: FavoritesRoute,
  GlossaryRoute: GlossaryRoute,
  ImpersonateRoute: ImpersonateRoute,
  MethodRoute: MethodRoute,
  OfflineRoute: OfflineRoute,
  PricingRoute: PricingRoute,
  ProgressRoute: ProgressRoute,
  SearchRoute: SearchRoute,
  SettingsRoute: SettingsRouteWithChildren,
  TrashRoute: TrashRoute,
  WeakSpotsRoute: WeakSpotsRoute,
  AudioRecapsIdRoute: AudioRecapsIdRoute,
  AudioRecapsNewRoute: AudioRecapsNewRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  AuthLoginRoute: AuthLoginRoute,
  BillingCheckoutRoute: BillingCheckoutRoute,
  BillingSuccessRoute: BillingSuccessRoute,
  CatalogSlugRoute: CatalogSlugRoute,
  CollectionsSetIdRoute: CollectionsSetIdRoute,
  CoursesCourseIdRoute: CoursesCourseIdRoute,
  CoursesCalendarRoute: CoursesCalendarRoute,
  CoursesCatalogRoute: CoursesCatalogRoute,
  CoursesNewRoute: CoursesNewRoute,
  CoursesTemplatesRoute: CoursesTemplatesRoute,
  FlashcardsMarkedRoute: FlashcardsMarkedRoute,
  LegalKindRoute: LegalKindRoute,
  LegalAcceptRoute: LegalAcceptRoute,
  MaterialsMaterialIdRoute: MaterialsMaterialIdRoute,
  MaterialsTrashRoute: MaterialsTrashRoute,
  NotesNoteIdRoute: NotesNoteIdRoute,
  NotificationsIdRoute: NotificationsIdRoute,
  OnboardingDoneRoute: OnboardingDoneRoute,
  OnboardingLanguageRoute: OnboardingLanguageRoute,
  OnboardingMethodRoute: OnboardingMethodRoute,
  OnboardingRhythmRoute: OnboardingRhythmRoute,
  RecordingsIdRoute: RecordingsIdRoute,
  RecordingsNewRoute: RecordingsNewRoute,
  SharedTokenRoute: SharedTokenRoute,
  StudyPlanIdRoute: StudyPlanIdRoute,
  StudyPlanCalendarRoute: StudyPlanCalendarRoute,
  StudyPlanTemplatesRoute: StudyPlanTemplatesRoute,
  TutorSessionIdRoute: TutorSessionIdRoute,
  TutorScenariosRoute: TutorScenariosRoute,
  TutorSkillsRoute: TutorSkillsRoute,
  VoiceTutorNewRoute: VoiceTutorNewRoute,
  AudioRecapsIndexRoute: AudioRecapsIndexRoute,
  CollectionsIndexRoute: CollectionsIndexRoute,
  CoursesIndexRoute: CoursesIndexRoute,
  FlashcardsIndexRoute: FlashcardsIndexRoute,
  LibraryIndexRoute: LibraryIndexRoute,
  MaterialsIndexRoute: MaterialsIndexRoute,
  NotesIndexRoute: NotesIndexRoute,
  NotificationsIndexRoute: NotificationsIndexRoute,
  OnboardingIndexRoute: OnboardingIndexRoute,
  RecordingsIndexRoute: RecordingsIndexRoute,
  StudyPlanIndexRoute: StudyPlanIndexRoute,
  TestsIndexRoute: TestsIndexRoute,
  TutorIndexRoute: TutorIndexRoute,
  VoiceTutorIndexRoute: VoiceTutorIndexRoute,
  AudioRecapsShareTokenRoute: AudioRecapsShareTokenRoute,
  BillingRefundStatusRefundIdRoute: BillingRefundStatusRefundIdRoute,
  CharactersSessionsIdRoute: CharactersSessionsIdRoute,
  CoursesCatalogTemplateIdRoute: CoursesCatalogTemplateIdRoute,
  CoursesTemplatesTemplateIdRoute: CoursesTemplatesTemplateIdRoute,
  FlashcardsSetsSetIdRoute: FlashcardsSetsSetIdRoute,
  FlashcardsStudySetIdRoute: FlashcardsStudySetIdRoute,
  LibraryFoldersFolderIdRoute: LibraryFoldersFolderIdRoute,
  MaterialsMaterialIdNotesRoute: MaterialsMaterialIdNotesRoute,
  MaterialsSetsSetIdRoute: MaterialsSetsSetIdRoute,
  TestsEditIdRoute: TestsEditIdRoute,
  TestsResultsAttemptIdRoute: TestsResultsAttemptIdRoute,
  TestsTakeIdRoute: TestsTakeIdRoute,
  ToolsEssayIdRoute: ToolsEssayIdRoute,
  ToolsVisualExplainerIdRoute: ToolsVisualExplainerIdRoute,
  ToolsVisualsIdRoute: ToolsVisualsIdRoute,
  VoiceTutorSessionIdRoute: VoiceTutorSessionIdRoute,
  LibraryFoldersIndexRoute: LibraryFoldersIndexRoute,
  MaterialsSetsIndexRoute: MaterialsSetsIndexRoute,
  ToolsEssayIndexRoute: ToolsEssayIndexRoute,
  ToolsVisualExplainerIndexRoute: ToolsVisualExplainerIndexRoute,
  ToolsVisualsIndexRoute: ToolsVisualsIndexRoute,
  CoursesCourseIdTopicsTopicIdRoute: CoursesCourseIdTopicsTopicIdRoute,
  StudyPlanIdSubsectionSubIdRoute: StudyPlanIdSubsectionSubIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
